import { Divider } from 'src/components/atoms';
import { StyledSubheader } from 'src/components/foundations/foundations.styles';
import {
  AccessStepDescription,
  GlobalAccessContainer,
} from 'src/components/molecules/InviteToCaseModal/Steps/AccessStep.styles';
import { GlobalAccess } from 'src/components/molecules/InviteToCaseModal/components/GlobalAccess/GlobalAccess';
import { HeaderRow } from './HeaderRow';

interface GlobalAccessDetailsProps {
  hasAllEditPermissions: boolean;
  hasAllViewPermissions: boolean;
  hasSomeEditPermissions: boolean;
  overrideDisplay?: boolean;
  disableFields?: boolean;
  displayDivider?: boolean;
  name?: string;
  caseDisplayId: string;
  handleEditAccess?: () => void;
  handleViewAccess?: () => void;
}

export const GlobalAccessDetails = ({
  hasAllEditPermissions,
  hasSomeEditPermissions,
  hasAllViewPermissions,
  overrideDisplay = false,
  disableFields = true,
  displayDivider = true,
  name,
  caseDisplayId,
  handleEditAccess,
  handleViewAccess,
}: GlobalAccessDetailsProps) => {
  return (
    <>
      {displayDivider && <Divider variant="horizontal" />}
      <HeaderRow
        icon="lock"
        title={`${
          name ? `${name}'s` : 'Total'
        } access to case ID ${caseDisplayId}`}
      />
      <GlobalAccessContainer>
        {(overrideDisplay ||
          (hasAllEditPermissions && hasAllViewPermissions)) && (
          <GlobalAccess
            globalAccess={hasAllEditPermissions}
            onClick={() => (handleEditAccess ? handleEditAccess() : {})}
            data-testid={'all-edit-access'}
            disabled={disableFields}
          >
            <StyledSubheader>{'Editor access'}</StyledSubheader>
            <AccessStepDescription>
              Grant full control and unrestricted editing for the entire case,
              allowing modification of all relevant information.
            </AccessStepDescription>
          </GlobalAccess>
        )}

        {(overrideDisplay ||
          (hasAllViewPermissions && !hasSomeEditPermissions)) && (
          <GlobalAccess
            globalAccess={hasAllEditPermissions ? false : hasAllViewPermissions}
            onClick={() => (handleViewAccess ? handleViewAccess() : {})}
            data-testid={'all-read-access'}
            disabled={disableFields}
          >
            <StyledSubheader>{'Read-only access'}</StyledSubheader>
            <AccessStepDescription>
              Grant read-only access for the entire case, allowing viewing of
              all relevant information.
            </AccessStepDescription>
          </GlobalAccess>
        )}
      </GlobalAccessContainer>
    </>
  );
};
